export const ExternalURLsHelper = {
  getAjudaRNPURL: () => {
    return process.env.REACT_APP_AJUDA_RNP_URL || '#';
  },
};